import { render, staticRenderFns } from "./feature.vue?vue&type=template&id=1daa19df&"
import script from "./feature.vue?vue&type=script&lang=ts&"
export * from "./feature.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports